import styled from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './swiper-wrapper.default.box';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const PcBox = styled(BasePcBox)`
    padding-top: 0.5rem;
`;

const MobileBox = styled(BaseMobileBox)`
    padding-top: 0;
`;


export const SwiperWrapperCasino777Box = styledByDevice(PcBox, MobileBox);